import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VpRulesService {

  constructor(protected http: HttpClient) { }

  import(formData): Observable<any> {
    return this.http.post('/vp-rules/import', formData);
  }
}
